import { BottomNavigation, withStyles } from "@material-ui/core";

export const StyledBottomNavigation = withStyles(() => ({
  root: {
    position: "fixed",
    bottom: 0,
    right: 0,
    left: 0,
    zIndex: 101,
    background: "rgba(0,0,0,0.8)",
    WebkitBackdropFilter: "saturate(180%) blur(20px)",
    backdropFilter: "saturate(180%) blur(20px)",
  },
}))(BottomNavigation);
